export const CORE_AMZL = "AMZL_CORE";
export const AR_V2 = "AR_NEXT_GEN";
export const SSD = "SSD";
export const AR = "AR";

export const ROUTE_VIEW = "ROUTE_VIEW";
export const HIGH_SPR = "High SPR";

export const VISUAL_GRID_VIEW = "VISUAL_GRID_VIEW";
export const TABULAR_GRID_VIEW = "TABULAR_GRID_VIEW";
export const ADDITIONAL_METRICS_VIEW = "ADDITIONAL_METRICS_VIEW";

export const DEFAULT_SPR_PACKAGE_COUNT = 270;
export const DEFAULT_SPR_TIME_LIMIT = 60;

//For Route Cut Filter
export const DEFAULT_RC_TIME_LIMIT = 4;
export const DEFAULT_RC_PACKAGE_COUNT = 4;

export const STRINGS = {
  EMPTY: "",
  TIMEOUT: "timeout",
};

export const DEFAULT_CAPABILITIES = [CORE_AMZL, SSD, AR];

export const STAGE_LOCATION_TYPE = {
  PLANNED: "PLANNED",
  NORMAL: "NORMAL",
  OVERFLOW: "OVERFLOW",
};
export const LOCATION_TYPE = {
  DOCK_DOOR: "DOCK_DOOR",
  STAGING_AREA: "STAGING_AREA",
};
export const PERCENTAGE = "%";
export const DEFAULT_REFRESH_INTERVAL = 60 * 1000; // 1 minute.
export const NOT_APPLICABLE = "N/A";

export const FEATURES = {
  IS_RSWS_BOSON_FLOW_ENABLED: "isRSWSBosonFlowEnabled",
};



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/util/Constants.js